import { useState } from "react";
import { usePWAContext } from "./PWAProvider";
import { MdGetApp, MdClose, MdWifi } from "react-icons/md";

const InstallPrompt = () => {
  const { isInstallable, isInstalled, installPWA } = usePWAContext();
  const [dismissed, setDismissed] = useState(false);

  if (!isInstallable || isInstalled || dismissed) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-xl shadow-xl border border-blue-100 p-4 z-50">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2">
          <div className="bg-blue-600 p-2 rounded-lg">
            <MdWifi size={20} className="text-white" />
          </div>
          <div>
            <p className="font-semibold text-gray-800 text-sm">
              Install SarifiMesh
            </p>
            <p className="text-xs text-gray-500">Add to your home screen</p>
          </div>
        </div>
        <button
          onClick={() => setDismissed(true)}
          className="text-gray-400 hover:text-gray-600"
        >
          <MdClose size={18} />
        </button>
      </div>

      <p className="text-xs text-gray-600 mb-3">
        Install SarifiMesh as an app for faster access, offline support,
        and push notifications.
      </p>

      <div className="flex gap-2">
        <button
          onClick={() => setDismissed(true)}
          className="flex-1 border border-gray-200 text-gray-600 py-2 rounded-lg text-xs hover:bg-gray-50"
        >
          Not now
        </button>
        <button
          onClick={installPWA}
          className="flex-1 bg-blue-600 text-white py-2 rounded-lg text-xs hover:bg-blue-700 flex items-center justify-center gap-1"
        >
          <MdGetApp size={14} />
          Install App
        </button>
      </div>
    </div>
  );
};

export default InstallPrompt;